$(function () {

    var navItems = $('.sidebar .subnav__list > .subnav__item');

    navItems.each(function(index, item) {
        var subNav = $(item).find('.subnav__sub-list');

        if ($(item).hasClass('subnav__item--active')) {
           subNav.removeClass('subnav__sub-list--hidden');
        }
    });

    $('.subnav__icon--clickable').each(function () {
        $(this).on('click', function (e) {

            e.preventDefault();

            $(this).toggleClass('subnav__icon--active');

            var subMenu = $(this).parent('li a').next('.subnav__sub-list');

            subMenu.toggleClass('subnav__sub-list--hidden');

        });
    });
});
